import React from 'react';
import { Modal as BootstrapModal } from 'react-bootstrap';

var Modal = function Modal(props) {
  var children = props.children,
      className = props.className,
      show = props.show,
      hide = props.hide,
      exited = props.exited,
      title = props.title,
      _props$titleSize = props.titleSize,
      titleSize = _props$titleSize === void 0 ? 'large' : _props$titleSize,
      titleColor = props.titleColor,
      locationColor = props.locationColor,
      backdrop = props.backdrop,
      size = props.size,
      _props$hideCloseButto = props.hideCloseButton,
      hideCloseButton = _props$hideCloseButto === void 0 ? false : _props$hideCloseButto,
      _props$noHeader = props.noHeader,
      noHeader = _props$noHeader === void 0 ? false : _props$noHeader;
  return /*#__PURE__*/React.createElement(BootstrapModal, {
    className: className,
    show: show,
    onHide: hide,
    onExited: exited,
    backdrop: backdrop,
    size: size,
    autoFocus: true,
    keyboard: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat("cb-modal__location-color--".concat(locationColor))
  }, !noHeader && /*#__PURE__*/React.createElement(BootstrapModal.Header, {
    className: "".concat("cb-modal__title-color--".concat(titleColor))
  }, /*#__PURE__*/React.createElement(BootstrapModal.Title, {
    className: "\n          cb-type-title-1\n          ".concat("cb-modal__title--".concat(titleSize), "\n          ")
  }, title), !hideCloseButton && /*#__PURE__*/React.createElement("button", {
    className: "button cb-modal__close",
    onClick: hide
  }, "x"), (className === null || className === void 0 ? void 0 : className.indexOf('loyalty-modal')) > -1 && /*#__PURE__*/React.createElement("button", {
    className: "cb-modal__close--loyalty",
    onClick: hide
  })), /*#__PURE__*/React.createElement(BootstrapModal.Body, null, noHeader && (className === null || className === void 0 ? void 0 : className.indexOf('loyalty-modal')) > -1 && /*#__PURE__*/React.createElement("button", {
    className: "cb-modal__close--loyalty",
    onClick: hide
  }), children)));
};

export var ModalNoHeader = function ModalNoHeader(props) {
  var children = props.children,
      className = props.className,
      show = props.show,
      hide = props.hide,
      exited = props.exited,
      title = props.title,
      _props$titleSize2 = props.titleSize,
      titleSize = _props$titleSize2 === void 0 ? 'large' : _props$titleSize2,
      backdrop = props.backdrop,
      size = props.size;
  return /*#__PURE__*/React.createElement(BootstrapModal, {
    className: className,
    show: show,
    onHide: hide,
    onExited: exited,
    backdrop: backdrop,
    size: size,
    autoFocus: true,
    keyboard: true
  }, /*#__PURE__*/React.createElement(BootstrapModal.Header, null, children, /*#__PURE__*/React.createElement("button", {
    className: "button cb-modal__close",
    onClick: hide
  }, "x")));
};
Modal.defaultProps = {
  title: '',
  backdrop: 'static'
};
ModalNoHeader.defaultProps = {
  title: '',
  backdrop: 'static'
};
export default Modal;